import React, { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import classes from "./suggestedProduct.module.css";

const IMAGE_WIDTH = 60;

const SuggestedProduct = (props) => {
  const { product, onNavigate } = props;

  const handleClick = useCallback(() => {
    if (typeof onNavigate === "function") {
      onNavigate();
    }
  }, [onNavigate]);

  return (
    <>
      <Link
        className={classes.root}
        to={`/product/${product.url_key}.html`}
        onClick={handleClick}
      >
        <img
          alt={product.name}
          classes={{ image: classes.thumbnail, root: classes.image }}
          src={product.small_image.url}
          width={IMAGE_WIDTH}
        />
        <span className={classes.name}>{product.name}</span>
        <span className={classes.price}>
          {product.__typename.toLowerCase() !== "bundleproduct" ? (
            <>
              <span>
                {product.price_range.maximum_price.regular_price.currency}
              </span>
              <span>
                {product.price_range.maximum_price.regular_price.value}
              </span>
            </>
          ) : null}
        </span>
      </Link>
    </>
  );
};

export default SuggestedProduct;
